// actions/authActions.js
export const setUser = (user) => ({
    type: "SET_USER",
    payload: user,
  });
  
  export const setAuthenticated = (status) => ({
    type: "SET_AUTHENTICATED",
    payload: status,
  });
  

  // Redux slice action for cart
export const updateCartInRedux = (cart) => {
  return {
    type: 'UPDATE_CART',
    payload: cart,
  };
};
